// extracted by mini-css-extract-plugin
export default {"header":"contactoFooter_header__cZOsk","icon":"contactoFooter_icon__DzdPw"};